const ExternalArrow = () => {
  return (
    <svg
      data-testid="external-arrow-svg-icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M20.5 13V19C20.5 19.3978 20.342 19.7794 20.0607 20.0607C19.7794 20.342 19.3978 20.5 19 20.5H5C4.60218 20.5 4.22064 20.342 3.93934 20.0607C3.65804 19.7794 3.5 19.3978 3.5 19V5C3.5 4.60218 3.65804 4.22064 3.93934 3.93934C4.22064 3.65804 4.60218 3.5 5 3.5H11"
        stroke="#111111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14.5 3.5H20.5V9.5" stroke="#111111" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.5 10.5L20.5 3.5" stroke="#111111" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ExternalArrow;
